import React, { useEffect, useState, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';

import Loading from '../../../components/Loading';

import getResponseErrors from '../../../utils/getResponseErrors';

interface IUrlParams {
  id: string;
}

const ContratoTratamento: React.FC = () => {
  const { addToast } = useToast();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const [loading, setLoading] = useState(false);
  const [contrato, setContrato] = useState<string>('');

  const handleHTML = useCallback((texto: string) => {
    return texto
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }, []);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`/tratamento/contrato/${id}`);

        setContrato(handleHTML(response.data.ConContrato));
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados do contrato',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, [id, addToast, handleHTML]);

  return (
    <div className="p-0 m-0 bg-white">
      {loading && <Loading />}
      {contrato && <span dangerouslySetInnerHTML={{ __html: contrato }} />}
    </div>
  );
};

export default ContratoTratamento;
